<div class="bg-white rounded-lg border-lightest border-2 shadow-sm px-5 pt-5 pb-10">
  <h2
    *ngIf="isInitPassword"
    class="text-3xl text-center md:text-start font-app-bold mb-3">
    {{ "passwordMessages.initializePersonalSpace" | translate }}
  </h2>
  <h2
    *ngIf="!isInitPassword"
    class="text-3xl font-app-bold mb-3 text-center md:text-start">
    {{ "passwordMessages.passwordResetTitle" | translate }}
  </h2>
  <form
    [formGroup]="formGroup"
    (ngSubmit)="onSubmit()">
    <div>
      <div class="flex justify-between items-center">
        <label
          for="newPassword"
          class="text-dark mb-2">
          {{ "passwordMessages.newPassword" | translate }}
        </label>
      </div>
      <p-password
        id="newPassword"
        formControlName="newPassword"
        required
        class="flex w-full border-[1px] rounded-lg border-light mt-1 p-3"
        [placeholder]="'passwordMessages.enterPassword' | translate"
        [toggleMask]="true"
        [feedback]="false"
        [autofocus]="false"></p-password>
      <app-password-error
        [formGroup]="formGroup"
        controlName="newPassword"></app-password-error>
    </div>
    <div class="mb-5">
      <div class="flex justify-between items-center">
        <label
          for="confirmPassword"
          class="mt-5 mb-2 text-dark">
          {{ "passwordMessages.confirmNewPassword" | translate }}
        </label>
      </div>
      <p-password
        id="confirmPassword"
        formControlName="confirmPassword"
        required
        class="flex w-full border-[1px] rounded-lg border-light mt-1 p-3"
        [placeholder]="'passwordMessages.enterPassword' | translate"
        [toggleMask]="true"
        [feedback]="false"
        [autofocus]="false"></p-password>
      <small
        class="p-error"
        *ngIf="
          (formGroup.get('confirmPassword')?.touched || formGroup.get('confirmPassword')?.dirty) &&
          formGroup.get('confirmPassword')?.errors?.['passwordMismatch']
        ">
        {{ "passwordMessages.passwordMismatch" | translate }}
      </small>
    </div>
    <div
      *ngIf="isInitPassword"
      class="flex flex-col md:flex-row text-left justify-between mb-5 text-dark">
      <p>
        {{ "passwordMessages.acceptTerms" | translate }}
      </p>
    </div>
    <div class="text-center md:text-left">
      <button
        pButton
        [label]="
          isInitPassword ? ('passwordMessages.submit' | translate) : ('passwordMessages.loginButton' | translate)
        "
        type="submit"
        class="block rounded-md py-3 px-5 bg-primary text-white w-full text-center"
        [disabled]="!formGroup.valid"></button>
    </div>
  </form>
</div>
